import React from "react";
var ThemeContext = React.createContext({});
var ThemeConsumer = ThemeContext.Consumer;
export default ThemeContext;
export { ThemeConsumer, ThemeContext };
